import "./App.css";
import "./styles/ComponentsStyle.css";
import { AppRouter } from "./router/AppRouter";
import SnackbarContainer from "./components/Snackbar";

function App() {
  return (
    <div className="App">
      <AppRouter />
      <SnackbarContainer />
    </div>
  );
}

export default App;
